import PropTypes from 'prop-types';

export default function NoData({ message }) {
  return (
    <div className="no-data-container">
      <div className="no-data">
        {message ? (
          <span className="text-msg">{message}</span>
        ) : (
          <div className="message-container">
            <p className="text-msg">No data is available on selected date(s)</p>
            <p className="text-msg">Please select the different date(s) / filters</p>
          </div>
        )}
      </div>
    </div>
  );
}

NoData.propTypes = {
  message: PropTypes.string.isRequired,
};
